import persons from './defaultPersons'

/* ***************************** Action Types ****************************** */
const actionTypes = {
  addPersons: 'addPersonsAction',
  disableFirstLoad: 'disableFirstLoadAction',
  hideFormErrors: 'hideFormErrorsAction',
  displayFormErrors: 'displayFormErrorsAction',
  login: 'loginAction',
  logout: 'logoutAction',
  rememberPerson: 'rememberPersonAction',
  reset: 'resetAction',
  storeScrollPosition: 'storeScrollPositionAction',
}
export default actionTypes

/* ******************************** Actions ******************************** */
export const displayFormErrorsAction = () => ({
  type: actionTypes.displayFormErrors,
})
export const hideFormErrorsAction = () => ({
  type: actionTypes.hideFormErrors,
})
export const loginAction = () => ({
  type: actionTypes.login,
})
export const logoutAction = () => ({
  type: actionTypes.logout,
})
export const rememberPersonAction = (slug) => ({
  type: actionTypes.rememberPerson,
  slug,
})
export const resetAction = () => ({
  type: actionTypes.reset,
})
export const storeScrollPositionAction = (scrollPosition) => ({
  type: actionTypes.storeScrollPosition,
  scrollPosition,
})

/* **************************** Private Actions **************************** */
/* These actions should not be called directly by components.
 * They are used by asynchronous actions.
 */
export const addPersonsAction = (persons) => ({
  /* used in simulateLoadAction */
  type: actionTypes.addPersons,
  persons,
})
export const disableFirstLoadAction = () => ({
  /* used in simulateLoadAction */
  type: actionTypes.disableFirstLoad,
})

/* **************************** Async Actions ****************************** */
export const simulateLoadAction = () =>
  (dispatch, getState) => {
    dispatch(addPersonsAction(persons))
    setTimeout(() => dispatch(disableFirstLoadAction()), 1000)
  }
export const authenticate = (router) =>
  (dispatch, getState) => {
    dispatch(loginAction())
    router.push({ pathname: '/gallery' })
    // wait until after transition to clear form of errors
    setTimeout(() => dispatch(hideFormErrorsAction()), 1000)
  }
export const deauthenticate = (router) =>
  (dispatch, getState) => {
    dispatch(logoutAction())
    router.push({ pathname: '/' })
  }



// WEBPACK FOOTER //
// ./src/gallery/actions.js